import PreviewEnvBanner from "@/components/PreviewEnvBanner";
import "@/App.css";
import { lazy, Suspense, useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { toast } from "sonner";
import ErrorBoundary from "@/components/ErrorBoundary";
import ScrollToTop from "@/components/ScrollToTop";
import { installStabilityGuards } from "@/lib/stability";
import { applyMarkTestFromUrl } from "@/lib/testDevice";
const WelcomePage = lazy(() => import("@/pages/WelcomePage"));
const JournalPage = lazy(() => import("@/pages/JournalPage"));
const CaptainJournalPage = lazy(() => import("@/pages/CaptainJournalPage"));
const LimaniPage = lazy(() => import("@/pages/LimaniPage"));
const ZoomGatePage = lazy(() => import("@/pages/ZoomGatePage"));
const GroupInterestPage = lazy(() => import("@/pages/GroupInterestPage"));
const DormantContactsPage = lazy(() => import("@/pages/DormantContactsPage"));
const QuizPage = lazy(() => import("@/pages/QuizPage"));
const QuizLikertPage = lazy(() => import("@/pages/QuizLikertPage"));
const UserInfoPage = lazy(() => import("@/pages/UserInfoPage"));
const ResultsPage = lazy(() => import("@/pages/ResultsPage"));
const AdminRouter = lazy(() => import("@/pages/AdminRouter"));
const LeadDetailPage = lazy(() => import("@/pages/LeadDetailPage"));
const LandingPage = lazy(() => import("@/pages/LandingPage"));
const OrganicLandingPage = lazy(() => import("@/pages/OrganicLandingPage"));
const DiscoverPage = lazy(() => import("@/pages/DiscoverPage"));
const UnlockPage = lazy(() => import("@/pages/UnlockPage"));
const UnsubscribePage = lazy(() => import("@/pages/UnsubscribePage"));
const QuizMockup = lazy(() => import("@/pages/QuizMockup"));
const QuizMockupV2 = lazy(() => import("@/pages/QuizMockupV2"));
const PlatformPage = lazy(() => import("@/pages/PlatformPage"));
const WorkshopRegisterPage = lazy(() => import("@/pages/WorkshopRegisterPage"));
const SimulatorPage = lazy(() => import("@/pages/SimulatorPage"));
import PiratePagesEditor from "@/components/admin/PiratePagesEditor";
const PeirateiaPage = lazy(() => import("@/pages/PeirateiaPage"));
const PiratePage = lazy(() => import("@/pages/PiratePage"));
const PneumatikiParakampsiPage = lazy(() => import("@/pages/PneumatikiParakampsiPage"));
const TehnikaPage = lazy(() => import("@/pages/TehnikaPage"));
const ProelefsiPage = lazy(() => import("@/pages/ProelefsiPage"));
const HeartworksPage = lazy(() => import("@/pages/HeartworksPage"));
const RepermissionPage = lazy(() => import("@/pages/RepermissionPage"));
const HeartMathPage = lazy(() => import("@/pages/HeartMathPage"));
const HeartMathCertificationsPage = lazy(() => import("@/pages/HeartMathCertificationsPage"));
const DimiourgosPage = lazy(() => import("@/pages/DimiourgosPage"));
const IsosPage = lazy(() => import("@/pages/IsosPage"));
const TrietisEkpaidevsiPage = lazy(() => import("@/pages/TrietisEkpaidevsiPage"));
const TrietisKostosPage = lazy(() => import("@/pages/TrietisKostosPage"));
const DiscoveryCallGuidePage = lazy(() => import("@/pages/DiscoveryCallGuidePage"));
const StratigikiPage = lazy(() => import("@/pages/StratigikiPage"));
const DiadromiPage = lazy(() => import("@/pages/DiadromiPage"));
const ErotimatologioPage = lazy(() => import("@/pages/ErotimatologioPage"));
const ErotimatologioAdminPage = lazy(() => import("@/pages/ErotimatologioAdminPage"));
const VideoProgressAdminPage = lazy(() => import("@/pages/VideoProgressAdminPage"));
const PacerPage = lazy(() => import("@/pages/PacerPage"));
const ProgramPreviewRedirect = lazy(() => import("@/pages/ProgramPreviewRedirect"));
const PlatformaAdminPage = lazy(() => import("@/pages/PlatformaAdminPage"));
const VimataCheckoutPage = lazy(() => import("@/pages/VimataCheckoutPage"));
const ConversionQueuePage = lazy(() => import("@/pages/ConversionQueuePage"));
const PromotionPage = lazy(() => import("@/pages/PromotionPage"));
const SixWeeksPage = lazy(() => import("@/pages/SixWeeksPage"));
const ProgramPage = lazy(() => import("@/pages/ProgramPage"));
const SharedSectionPage = lazy(() => import("@/pages/SharedSectionPage"));
const SharedItemPage = lazy(() => import("@/pages/SharedItemPage"));
const ProgramLoginPage = lazy(() => import("@/pages/ProgramLoginPage"));

// Στατική σελίδα HTML από το /public (π.χ. /eisodos → /eisodos.html)
function StaticHtml({ file }) {
  useEffect(() => { window.location.replace(file + window.location.search); }, [file]);
  return null;
}
const EarlyAccessPage = lazy(() => import("@/pages/EarlyAccessPage"));
const MorningCallPage = lazy(() => import("@/pages/MorningCallPage"));
const MorningCallSuccessPage = lazy(() => import("@/pages/MorningCallSuccessPage"));
const MorningCallAdminPage = lazy(() => import("@/pages/MorningCallAdminPage"));
const FreePreviewPage = lazy(() => import("@/pages/FreePreviewPage"));
const ResultsPreviewPage = lazy(() => import("@/pages/ResultsPreviewPage"));
const QuizBridgePage = lazy(() => import("@/pages/QuizBridgePage"));
const PiratesPresentationPage = lazy(() => import("@/pages/PiratesPresentationPage"));
const WebinarParousiasiPage = lazy(() => import("@/pages/WebinarParousiasiPage"));
const WebinarRegisterPage = lazy(() => import("@/pages/WebinarRegisterPage"));
const EmailConfirmedPage = lazy(() => import("@/pages/EmailConfirmedPage"));
const BookingConfirmPage = lazy(() => import("@/pages/BookingConfirmPage"));
const UmbrellaPage = lazy(() => import("@/pages/UmbrellaPage"));
const OptinPage = lazy(() => import("@/pages/OptinPage"));
const MethodPage = lazy(() => import("@/pages/MethodPage"));
const SessionPage = lazy(() => import("@/pages/SessionPage"));
const WorkshopSignupPage = lazy(() => import("@/pages/WorkshopSignupPage"));
const ThankYouWorkshopPage = lazy(() => import("@/pages/ThankYouWorkshopPage"));
const PatanjaliSalesPage = lazy(() => import("@/pages/PatanjaliSalesPage"));
const PitchPage = lazy(() => import("@/pages/PitchPage"));
const WeeklyEmailAdminPage = lazy(() => import("@/pages/WeeklyEmailAdminPage"));
const StripePaymentsAdminPage = lazy(() => import("@/pages/StripePaymentsAdminPage"));
const TherapyIntakePage = lazy(() => import("@/pages/TherapyIntakePage"));
const IntakesAdminPage = lazy(() => import("@/pages/IntakesAdminPage"));
const PatanjaliSuccessPage = lazy(() => import("@/pages/PatanjaliSuccessPage"));
const TrietisSuccessPage = lazy(() => import("@/pages/TrietisSuccessPage"));
const EightWeeksSuccessPage = lazy(() => import("@/pages/EightWeeksSuccessPage"));
const PiratesBrowsePage = lazy(() => import("@/pages/PiratesBrowsePage"));
const CountdownPage = lazy(() => import("@/pages/CountdownPage"));
const MembersPage = lazy(() => import("@/pages/MembersPage"));
const GymnastirioPage = lazy(() => import("@/pages/GymnastirioPage"));
const AskisiOrasPage = lazy(() => import("@/pages/AskisiOrasPage"));
const AdminAskisiOrasPage = lazy(() => import("@/pages/AdminAskisiOrasPage"));
const DoreanPage = lazy(() => import("@/pages/DoreanPage"));
const ParousiasiPage = lazy(() => import("@/pages/ParousiasiPage"));
const TimitikiThesiPage = lazy(() => import("@/pages/TimitikiThesiPage"));
const Challenge7Page = lazy(() => import("@/pages/Challenge7Page"));
const VideoAccessPage = lazy(() => import("@/pages/VideoAccessPage"));
const ProfessionalUsePage = lazy(() => import("@/pages/ProfessionalUsePage"));
const PatanjaliReadPage = lazy(() => import("@/pages/PatanjaliReadPage"));
const QuizClusterEntry = lazy(() => import("@/pages/QuizClusterEntry"));
const MVP4ProgramRedirect = lazy(() => import("@/pages/MVP4ProgramRedirect"));
const Week8w01Page = lazy(() => import("@/pages/Week8w01Page"));
const DemoKlisiPage = lazy(() => import("@/pages/DemoKlisiPage"));
const SynantisiRedirect = lazy(() => import("@/pages/SynantisiRedirect"));
const EkpaideusiToolPage = lazy(() => import("@/pages/EkpaideusiToolPage"));
const PilotFeedbackPage = lazy(() => import("@/pages/PilotFeedbackPage"));
const PilotPage = lazy(() => import("@/pages/PilotPage"));
const LeadManagementPage = lazy(() => import("@/leadmgmt").then((m) => ({ default: m.LeadManagementPage })));
const EmailSafetyPage = lazy(() => import("@/emailmodule").then((m) => ({ default: m.EmailSafetyPage })));
const ConsentAuditPage = lazy(() => import("@/consentaudit/ConsentAuditPage"));
const SocialManagementPage = lazy(() => import("@/socialmgmt").then((m) => ({ default: m.SocialManagementPage })));
const BrandManagementPage = lazy(() => import("@/brandmgmt").then((m) => ({ default: m.BrandManagementPage })));
const CalendlyManagementPage = lazy(() => import("@/calendlymgmt").then((m) => ({ default: m.CalendlyManagementPage })));
const PrivatePagesManagementPage = lazy(() => import("@/privatepagesmgmt").then((m) => ({ default: m.PrivatePagesManagementPage })));
const SupervisorPage = lazy(() => import("@/supervisorpage").then((m) => ({ default: m.SupervisorPage })));
const MailsPage = lazy(() => import("@/mailsmgmt").then((m) => ({ default: m.MailsPage })));
const AdminLinksPage = lazy(() => import("@/pages/AdminLinksPage"));
const ModulesPage = lazy(() => import("@/pages/ModulesPage"));
const QuickLogPage = lazy(() => import("@/pages/QuickLogPage"));
const FlyerPraktikiPage = lazy(() => import("@/pages/FlyerPraktikiPage"));

const PreviewAllowed = ({ children }) => {
  try { sessionStorage.setItem("allow_preview", "1"); } catch { /* ignore */ }
  return children;
};
const GmailCleanupPage = lazy(() => import("@/pages/GmailCleanupPage"));
const ReplayPage = lazy(() => import("@/pages/ReplayPage"));
const NurturingMailsPage = lazy(() => import("@/pages/NurturingMailsPage"));
const NameCurationPage = lazy(() => import("./pages/NameCurationPage"));
const AmesiSynoxiPage = lazy(() => import("./pages/AmesiSynoxiPage"));
const KardiakiAnapnoiPage = lazy(() => import("./pages/KardiakiAnapnoiPage"));
const PiratesDepthPage = lazy(() => import("./pages/PiratesDepthPage"));
const AnalysiThematosPage = lazy(() => import("./pages/AnalysiThematosPage"));
const AnalyseisAdminPage = lazy(() => import("./pages/AnalyseisAdminPage"));
const AnalysiPeiratiPage = lazy(() => import("./pages/AnalysiPeiratiPage"));
const AnalysiIstorikoPage = lazy(() => import("./pages/AnalysiIstorikoPage"));
const ExperiencesBeliefsPage = lazy(() => import("./pages/ExperiencesBeliefsPage"));
const PiratesLevel2Page = lazy(() => import("./pages/PiratesLevel2Page"));
const PaymentSuccessPage = lazy(() => import("./pages/PaymentResultPages").then((m) => ({ default: m.PaymentSuccessPage })));
const PaymentCancelPage = lazy(() => import("./pages/PaymentResultPages").then((m) => ({ default: m.PaymentCancelPage })));
const SegmentThanksPage = lazy(() => import("./pages/SegmentThanksPage"));
const VideoLibraryPage = lazy(() => import("./pages/VideoLibraryPage"));
const TetradioPage = lazy(() => import("./pages/TetradioPage"));
const KanonasPeiratiPage = lazy(() => import("./pages/KanonasPeiratiPage"));
const KoinotitaParousiasiPage = lazy(() => import("./pages/KoinotitaParousiasiPage"));
import { FontSizeControls } from "./components/FontSizeControls";
import { VisitorAssistant } from "./components/VisitorAssistant";
import { AdminAssistant } from "./components/AdminAssistant";
import { MemberGate } from "./components/MemberGate";
const PiratesPage = lazy(() => import("@/piratesmgmt").then((m) => ({ default: m.PiratesPage })));
import { Toaster } from "sonner";
import { KoinotitaReturnChip } from "./components/KoinotitaReturnChip";

function App() {
  // Handle `?mark_test=1|0` once per page load — lets the admin mark
  // any device (phone, second laptop) as a test device just by opening
  // a special URL. The flag is then persisted in localStorage.
  useEffect(() => {
    installStabilityGuards();
    const result = applyMarkTestFromUrl();
    if (result === true) {
      toast.success("Αυτή η συσκευή σημαδεύτηκε ως δοκιμαστική. Οι συμμετοχές σου δεν θα μετράνε.");
    } else if (result === false) {
      toast.info("Αυτή η συσκευή δεν είναι πλέον δοκιμαστική.");
    }
  }, []);

  return (
    <div className="App">
      <Toaster position="top-center" richColors />
      <PreviewEnvBanner />
      <FontSizeControls />
      <ErrorBoundary>
        <BrowserRouter>
        <ScrollToTop />
        <KoinotitaReturnChip />
        <VisitorAssistant />
        <AdminAssistant />
        <Suspense fallback={<div className="min-h-screen flex items-center justify-center" style={{ background: "#0B1A2E" }}><div className="w-10 h-10 rounded-full border-4 border-amber-400 border-t-transparent animate-spin" aria-label="Φόρτωση" /></div>}>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          {/* Duplicate landing για Facebook organic ads — tracks visits + attribution */}
          <Route path="/organic1" element={<OrganicLandingPage source="organic1" />} />
          <Route path="/organic2" element={<OrganicLandingPage source="organic2" />} />
          <Route path="/organic3" element={<OrganicLandingPage source="organic3" />} />
          <Route path="/welcome" element={<WelcomePage />} />
          <Route path="/q" element={<QuizClusterEntry />} />
          <Route path="/program-mvp4" element={<MVP4ProgramRedirect />} />
          <Route path="/start" element={<UmbrellaPage />} />
          <Route path="/hub" element={<UmbrellaPage />} />
          <Route path="/quiz" element={<QuizPage />} />
          <Route path="/quiz-likert" element={<QuizLikertPage />} />
          <Route path="/quiz-mockup" element={<QuizMockup />} />
          <Route path="/quiz-mockup-v2" element={<QuizMockupV2 />} />
          <Route path="/user-info" element={<UserInfoPage />} />
          <Route path="/results" element={<ResultsPage />} />
          <Route path="/results-preview" element={<ResultsPreviewPage />} />
          <Route path="/unlock" element={<UnlockPage />} />
          <Route path="/quiz-bridge" element={<QuizBridgePage />} />
          {/* /parousiasi and /presentation → same as /workshop-register (consolidated after marketing audit) */}
          <Route path="/parousiasi" element={<WorkshopRegisterPage />} />
          <Route path="/presentation" element={<WorkshopRegisterPage />} />
          {/* Legacy alias — το «Ανοιχτό Εργαστήριο» δείχνει στο ίδιο page (unified). */}
          <Route path="/anoixto-ergastirio" element={<WorkshopRegisterPage />} />
          <Route path="/peirateia/anoixto-ergastirio" element={<WorkshopRegisterPage />} />
          <Route path="/program-8weeks" element={<Navigate to="/8vimata" replace />} />
          <Route path="/8weeks" element={<Navigate to="/8vimata" replace />} />
          <Route path="/webinar-parousiasi" element={<WebinarParousiasiPage />} />
          <Route path="/webinar" element={<WebinarRegisterPage />} />
          <Route path="/8weeks/enter" element={<Navigate to="/8vimata/plirosi?plan=efapax" replace />} />
          <Route path="/8weeks/pliromi" element={<Navigate to="/8weeks/enter" replace />} />
          <Route path="/8weeks/success" element={<EightWeeksSuccessPage />} />
          <Route path="/r/:submissionId" element={<ResultsPage />} />
          <Route path="/workshop-register" element={<WorkshopRegisterPage />} />
          {/* Simulator standalone landing (ad-friendly experiential entry point) */}
          <Route path="/imerologio" element={<JournalPage />} />
          <Route path="/imerologio-2" element={<JournalPage level2 />} />
          <Route path="/katagrafi" element={<JournalPage />} />
          <Route path="/kyvernitis" element={<CaptainJournalPage />} />
          <Route path="/ananeosi" element={<CaptainJournalPage />} />
          <Route path="/limani" element={<LimaniPage />} />
          <Route path="/zoom-ergastirio" element={<ZoomGatePage />} />
          <Route path="/thesi" element={<GroupInterestPage />} />
          <Route path="/simulator" element={<SimulatorPage />} />
          <Route path="/senaria" element={<SimulatorPage />} />
          <Route path="/before-after" element={<SimulatorPage />} />
          <Route path="/patanjali" element={<PatanjaliSalesPage />} />
          <Route path="/admin/pitch" element={<PitchPage />} />
          <Route path="/admin/weekly-email" element={<WeeklyEmailAdminPage />} />
          <Route path="/admin/pliromes" element={<StripePaymentsAdminPage />} />
          <Route path="/8w01" element={<Week8w01Page />} />
          <Route path="/demo-klisi" element={<DemoKlisiPage />} />
          <Route path="/synantisi/:n" element={<SynantisiRedirect />} />
          <Route path="/synantisi/:n/original" element={<SynantisiRedirect variant="original" />} />
          <Route path="/synantisi/:n/emvathynsi" element={<SynantisiRedirect variant="emvathynsi" />} />
          <Route path="/ekpaideusi/:tool" element={<EkpaideusiToolPage />} />
          <Route path="/forma-synedrias" element={<TherapyIntakePage />} />
          <Route path="/admin/synedries" element={<IntakesAdminPage />} />
          <Route path="/patanjali/success" element={<PatanjaliSuccessPage />} />
          <Route path="/patanjali/read/:token" element={<PatanjaliReadPage />} />
          <Route path="/unsubscribe" element={<UnsubscribePage />} />
          <Route path="/admin" element={<AdminRouter />} />
          <Route path="/admin/leads-management" element={<LeadManagementPage />} />
          <Route path="/admin/social-management" element={<SocialManagementPage />} />
          <Route path="/admin/brand-management" element={<BrandManagementPage />} />
          <Route path="/admin/calendly-management" element={<CalendlyManagementPage />} />
          <Route path="/admin/private-pages" element={<PrivatePagesManagementPage />} />
          <Route path="/admin/daily" element={<SupervisorPage />} />
          <Route path="/admin/mails" element={<MailsPage />} />
          <Route path="/admin/links" element={<AdminLinksPage />} />
          <Route path="/admin/modules" element={<ModulesPage />} />
          <Route path="/quick-log" element={<QuickLogPage />} />
          <Route path="/flyer-praktiki" element={<FlyerPraktikiPage />} />
          <Route path="/admin/gmail" element={<GmailCleanupPage />} />
          <Route path="/replay" element={<ReplayPage />} />
          <Route path="/ergastirio-replay" element={<ReplayPage />} />
          <Route path="/admin/nurturing" element={<NurturingMailsPage />} />
          <Route path="/admin/dormant" element={<DormantContactsPage />} />
          <Route path="/admin/names" element={<NameCurationPage />} />
          <Route path="/admin/pirates" element={<PiratesPage />} />
          <Route path="/admin/pirate-pages/:slug" element={<PiratePagesEditor />} />
          <Route path="/admin/pirate-pages" element={<PiratePagesEditor />} />
          <Route path="/admin/email-safety" element={<EmailSafetyPage />} />
          <Route path="/admin/consent-audit" element={<ConsentAuditPage />} />
          <Route path="/admin/lead/:leadId" element={<LeadDetailPage />} />
          <Route path="/discover" element={<LandingPage />} />
          <Route path="/peirateia" element={<PeirateiaPage />} />
          <Route path="/peirateia/pnematiki-parakampsi" element={<PneumatikiParakampsiPage />} />
          <Route path="/peirateia/tehnika" element={<TehnikaPage />} />
          <Route path="/peirateia/proelefsi" element={<ProelefsiPage />} />
          <Route path="/peirateia/heartworks" element={<HeartworksPage />} />
          <Route path="/heartworks" element={<RepermissionPage />} />
          <Route path="/heartmath" element={<HeartMathPage />} />
          <Route path="/heartmath/ekpaideusi" element={<HeartMathCertificationsPage />} />
          <Route path="/heartworks/pistopoiisi" element={<HeartMathCertificationsPage />} />
          <Route path="/peirateia/dimiourgos" element={<DimiourgosPage />} />
          <Route path="/peirateia/trietis" element={<TrietisEkpaidevsiPage />} />
          <Route path="/peirateia/trietis/kostos" element={<TrietisKostosPage />} />
          <Route path="/trietis-kostos" element={<TrietisKostosPage />} />
          <Route path="/kostos" element={<TrietisKostosPage />} />
          <Route path="/peirateia/trietis/success" element={<TrietisSuccessPage />} />
          <Route path="/peirateia/:slug" element={<PiratePage />} />
          <Route path="/6weeks" element={<SixWeeksPage />} />
          <Route path="/6evdomades" element={<SixWeeksPage />} />
          <Route path="/program" element={<ProgramPage />} />
          <Route path="/s/:shareId" element={<SharedSectionPage />} />
          <Route path="/i/:shareId" element={<SharedItemPage />} />
          <Route path="/enter" element={<ProgramLoginPage />} />
          <Route path="/eisodos" element={<StaticHtml file="/eisodos.html" />} />
          <Route path="/8vimata" element={<StaticHtml file="/8vimata.html" />} />
          <Route path="/8vimata-brand" element={<StaticHtml file="/8vimata-brand.html" />} />
          <Route path="/martyries" element={<StaticHtml file="/martyries.html" />} />
          <Route path="/isos" element={<IsosPage />} />
          <Route path="/8vimata/plirosi" element={<VimataCheckoutPage />} />
          <Route path="/early-access" element={<EarlyAccessPage />} />
          <Route path="/soon" element={<EarlyAccessPage />} />
          <Route path="/morning-call" element={<MorningCallPage />} />
          <Route path="/morning-call/success" element={<MorningCallSuccessPage />} />
          <Route path="/admin/morning-call" element={<MorningCallAdminPage />} />
          <Route path="/admin/call-guide" element={<DiscoveryCallGuidePage />} />
          <Route path="/admin/stratigiki" element={<StratigikiPage />} />
          <Route path="/admin/diadromi" element={<DiadromiPage />} />
          <Route path="/admin/erotimatologio" element={<ErotimatologioAdminPage />} />
          <Route path="/admin/theasi" element={<VideoProgressAdminPage />} />
          <Route path="/pacer" element={<PacerPage />} />
          <Route path="/admin/program-preview" element={<ProgramPreviewRedirect />} />
          <Route path="/admin/platforma" element={<PlatformaAdminPage />} />
          <Route path="/platforma" element={<ProgramPage showcase />} />
          <Route path="/erotimatologio" element={<ErotimatologioPage />} />
          <Route path="/admin/conversion" element={<ConversionQueuePage />} />
          <Route path="/admin/promotion" element={<PromotionPage />} />
          <Route path="/free-preview" element={<FreePreviewPage />} />
          <Route path="/email-confirmed" element={<EmailConfirmedPage />} />
          <Route path="/confirm/:bookingId" element={<BookingConfirmPage />} />
          <Route path="/platform" element={<PlatformPage />} />
          <Route path="/optin" element={<OptinPage />} />
          <Route path="/3-mathimata" element={<OptinPage />} />
          <Route path="/mini" element={<OptinPage />} />
          <Route path="/oi-peirates" element={<PiratesPresentationPage />} />
          <Route path="/peirates" element={<PiratesBrowsePage />} />
          <Route path="/peirates-epipedo-2" element={<MemberGate><PiratesLevel2Page /></MemberGate>} />
          <Route path="/ekpaideusi" element={<Navigate to="/8vimata" replace />} />
          <Route path="/payment/success" element={<PaymentSuccessPage />} />
          <Route path="/payment/cancel" element={<PaymentCancelPage />} />
          <Route path="/peirates-vathos" element={<MemberGate paid><PiratesDepthPage /></MemberGate>} />
          <Route path="/analysi-thematos" element={<MemberGate paid><AnalysiThematosPage /></MemberGate>} />
          <Route path="/analysi-peirati" element={<MemberGate product="level_b"><AnalysiPeiratiPage /></MemberGate>} />
          <Route path="/analisiB" element={<MemberGate product="level_b"><AnalysiPeiratiPage /></MemberGate>} />
          <Route path="/analysi-istoriko" element={<MemberGate paid><AnalysiIstorikoPage /></MemberGate>} />
          <Route path="/paidikes-empeiries" element={<MemberGate paid><ExperiencesBeliefsPage mode="exp" /></MemberGate>} />
          <Route path="/pepoithiseis-peirati" element={<MemberGate paid><ExperiencesBeliefsPage mode="bel" /></MemberGate>} />
          <Route path="/peirates2" element={<MemberGate><PiratesLevel2Page /></MemberGate>} />
          <Route path="/peirates3" element={<MemberGate paid><PiratesDepthPage /></MemberGate>} />
          <Route path="/countdown" element={<CountdownPage />} />
          <Route path="/koinotita" element={<MembersPage />} />
          <Route path="/gymnastirio" element={<GymnastirioPage />} />
          <Route path="/askisi-oras" element={<AskisiOrasPage />} />
          <Route path="/admin/askisi-oras" element={<AdminAskisiOrasPage />} />
          <Route path="/dorean" element={<DoreanPage />} />
          <Route path="/doro" element={<DoreanPage />} />
          <Route path="/epafi" element={<ParousiasiPage />} />
          <Route path="/timitiki-thesi" element={<TimitikiThesiPage />} />
          <Route path="/7imeres" element={<Challenge7Page />} />
          <Route path="/vinteo" element={<VideoAccessPage />} />
          <Route path="/praktiki" element={<GymnastirioPage bodyFirst />} />
          <Route path="/praktiki-dokimi" element={<PreviewAllowed><GymnastirioPage bodyFirst /></PreviewAllowed>} />
          <Route path="/askisi" element={<GymnastirioPage />} />
          <Route path="/amesi-synoxi" element={<MemberGate><AmesiSynoxiPage /></MemberGate>} />
          <Route path="/synoxi" element={<MemberGate><AmesiSynoxiPage /></MemberGate>} />
          <Route path="/kardiaki-anapnoi" element={<MemberGate><KardiakiAnapnoiPage /></MemberGate>} />
          <Route path="/members" element={<MembersPage />} />
          <Route path="/epaggelmatiki-xrisi" element={<ProfessionalUsePage />} />
          <Route path="/omada" element={<SegmentThanksPage />} />
          <Route path="/vinteothiki" element={<VideoLibraryPage />} />
          <Route path="/tetradio" element={<TetradioPage />} />
          <Route path="/kanonas-peirati" element={<KanonasPeiratiPage />} />
          <Route path="/parousiasi-koinotitas" element={<KoinotitaParousiasiPage />} />
          <Route path="/videos" element={<VideoLibraryPage />} />
          <Route path="/pirates" element={<PiratesPresentationPage />} />
          <Route path="/i-methodos" element={<MethodPage />} />
          <Route path="/methodos" element={<MethodPage />} />
          <Route path="/synedria" element={<SessionPage />} />
          <Route path="/session" element={<SessionPage />} />
          <Route path="/workshop-signup" element={<WorkshopSignupPage />} />
          <Route path="/thank-you-workshop" element={<ThankYouWorkshopPage />} />
          <Route path="/feedback/:token" element={<PilotFeedbackPage />} />
          <Route path="/admin/analyseis" element={<AnalyseisAdminPage />} />
          <Route path="/admin/pilot" element={<PilotPage />} />
        </Routes>
        </Suspense>
      </BrowserRouter>
      </ErrorBoundary>
    </div>
  );
}

export default App;